import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import { fetchIncrementalAlerts } from '../store/apps/alert';
import { AppDispatch } from 'src/store'
import SingleAlert from '../components/SingleAlert';
import { AlertState } from '../types/store/storeTypes';
import { styled } from '@mui/material/styles'
import { Card, Box, List, ListProps, Divider, CardHeader } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'


// ** Icon Imports


const StyledList = styled(List)<ListProps>(({ theme }) => ({
    '& .MuiListItem-container': {
        border: `1px solid ${theme.palette.divider}`,
        '&:first-of-type': {
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius
        },
        '&:last-child': {
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius
        },
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '& .MuiListItem-root': {
            paddingRight: theme.spacing(24)
        },
        '& .MuiListItemText-root': {
            marginTop: 0,
            '& .MuiTypography-root': {
                fontWeight: 500
            }
        }
    }
}))

const AlertList: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const alert = useSelector((state: AlertState) => state.alert); // Replace 'any' with your actual RootState type
    const hasMore = useSelector((state: AlertState) => state.alert.hasMore);

    useEffect(() => {
        dispatch(fetchIncrementalAlerts());
    }, [dispatch]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" sx={{ marginTop: "20px", marginBottom :"20px"}}>
            <Card sx={{ paddingBottom: "20px" }}>
                <CardHeader title="Notifications" />
                <InfiniteScroll
                    dataLength={alert.incrementalAlerts.length}
                    next={() => dispatch(fetchIncrementalAlerts())}
                    hasMore={hasMore}
                    loader={<LinearProgress />}
                >
                    <StyledList disablePadding>
                        {alert.incrementalAlerts.map((incAlert: any, index) => (<><SingleAlert key={incAlert.id} alert={incAlert} /> {index < alert.incrementalAlerts.length - 1 && <Divider />} </>))}
                    </StyledList>

                    {/*<List>*/}
                    {/*    {alert.incrementalAlerts.map((alert: any) => <SingleAlert key={alert.id} alert={alert} />)} */}{/* Replace 'any' with your actual Alert type */}
                    {/*</List>*/}
                </InfiniteScroll>
            </Card>
        </Box>
    );
};

export default AlertList;
